import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_upload, {
    ref: "upload",
    "file-list": _ctx.data.defaultImg,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => _ctx.data.defaultImg = $event),
    action: _ctx.data.upLoadUrl,
    data: _ctx.data.upLoadQuery,
    "on-preview": _ctx.handlerPreview,
    "before-upload": file => {
      return _ctx.hanlderFileSWH(file);
    },
    "on-success": (res, file, file_list) => {
      return _ctx.handlerSuccess(res, file, file_list);
    },
    "on-remove": (file, file_list) => {
      return _ctx.handlerRemove(file, file_list);
    },
    "on-exceed": (file, file_list) => {
      return _ctx.handlerExceed(file, file_list);
    },
    multiple: _ctx.data.isMultiple,
    limit: _ctx.data.parentData.limit,
    "auto-upload": "",
    "list-type": "picture-card",
    accept: ".jpg,.png"
  }, {
    default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("i", {
      class: "el-icon-plus"
    }, null, -1)])),
    _: 1,
    __: [2]
  }, 8, ["file-list", "action", "data", "on-preview", "before-upload", "on-success", "on-remove", "on-exceed", "multiple", "limit"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.data.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.data.dialogVisible = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_image, {
      width: "100%",
      src: _ctx.data.dialogImg,
      alt: ""
    }, null, 8, ["src"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}